module.exports = __webpack_public_path__ + "static/1347628652-wide.e53b0927.jpg";